export default "__VITE_ASSET__C9dHlYqT__"